import React from 'react'
import Experiment from '@mc/experiments-react'
import {
  PROMO_VARIABLE_NAMES,
  StyledFeatureVariable,
} from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import { PROMO_FEATURE_FLAG } from '@mc/promo-utils'
import { PROMO_I18N_NAMESPACE } from '../../../lib/constants'
import { GIFTING_ON_MOBILE_NAV_FLAG_NAME } from '../constants'
import { useGiftingOnMobileNav } from '../hooks/useGiftingOnMobileNav'

const GiftLinkVariant = ({ label }: { label: React.ReactNode }) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <div className='d-flex align-items-center'>
      <span className='flex-1'>{label}</span>
      <span
        className='mc-text-x-small mc-text--uppercase mc-ml-1 mc-bg-primary mc-text--bold mc-corners--1'
        style={{ padding: '2px 6px' }}
      >
        <StyledFeatureVariable
          flagName={PROMO_FEATURE_FLAG}
          variableName={PROMO_VARIABLE_NAMES.discountModalPromoOverriden.cta}
          defaultCopy={t(
            'common.home.modals.discount.promotionAppliedOnError.cta',
          )}
        />
      </span>
    </div>
  )
}

export const PlansMenuLink = ({ Control }: { Control: React.ReactNode }) => {
  const isGiftingOnMobileNav = useGiftingOnMobileNav()

  if (!isGiftingOnMobileNav) {
    return Control
  }

  return (
    <>
      <div className='d-none d-sm-block'>{Control}</div>
      <div className='d-sm-none'>
        <Experiment
          name={GIFTING_ON_MOBILE_NAV_FLAG_NAME}
          default={() => Control}
          variant_1={() => <GiftLinkVariant label={Control} />}
          track={false}
        />
      </div>
    </>
  )
}
